module.exports = __webpack_public_path__ + "f66dc44e1dda0f09b664319914c15ad3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Italic-webfont.ttf
// module id = 220
// module chunks = 0